/**
 * CMC Mega Menu — Concept 2: Sidebar hover interaction
 * Add to: Online Store → Themes → Edit code → Assets → theme.js (at the end)
 *
 * Handles the sidebar colour switcher inside the "Shop by Colour" mega menu.
 */
(function () {
  'use strict';

  function initColourSidebar() {
    var sidebarItems = document.querySelectorAll('.cmc-colour-sidebar-item');
    if (!sidebarItems.length) return;

    sidebarItems.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { activatePanel(btn); });
      btn.addEventListener('focus',      function () { activatePanel(btn); });
      btn.addEventListener('click',      function () { activatePanel(btn); });
    });
  }

  function activatePanel(btn) {
    var targetId = btn.getAttribute('data-colour-target');
    if (!targetId) return;

    var megaContent = btn.closest('.cmc-mega-colours');
    if (!megaContent) return;

    megaContent.querySelectorAll('.cmc-colour-sidebar-item').forEach(function (b) {
      b.classList.remove('is-active');
    });
    megaContent.querySelectorAll('.cmc-colour-panel').forEach(function (p) {
      p.classList.remove('is-active');
    });

    btn.classList.add('is-active');

    var targetPanel = document.getElementById(targetId);
    if (targetPanel) targetPanel.classList.add('is-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColourSidebar);
  } else {
    initColourSidebar();
  }
})();
